<template>
    <FormSection :error="form.getError('modules')">
        <template #title>
            Modules
        </template>

        <FormGroup
            name="multipart"
            label="Multipart Course"
            inline>
            <Checkbox
                name="multipart"
                ref="multipart"
                :modelValue="form.multipart"
                @update:modelValue="updateMultipart"/>
        </FormGroup>

        <div v-if="form.multipart" class="space-y-4">

            <AddSeparator @click="addModule(0)"/>

            <template v-for="(module, index) in modules" :key="module.id || module._id">
                <ModuleForm
                    :ref="setModuleRef"
                    :data-key="module.id || module._id"
                    :module="module"
                    :index="index"
                    @updated="moduleUpdated"
                    @remove="removeModule(module)"/>

                <AddSeparator @click="addModule(index + 1)"/>
            </template>
        </div>
    </FormSection>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import ModuleForm from "@/Pages/Admin/Courses/Components/ModuleForm";
import {keys, uniqueId} from "lodash";
import Checkbox from "@/Components/Form/Checkbox";
import FormGroup from "@/Components/Form/FormGroup";
import AddSeparator from "@/Pages/Admin/Courses/Components/AddSeparator"

export default {

    props: {
        course: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            lastEdited: null,
            moduleRefs: {},
        };
    },

    inject: ['form'],

    components: {
        FormSection,
        FormGroup,
        Checkbox,
        ModuleForm,
        AddSeparator
    },

    methods: {
        setModuleRef(el) {
            if (!el) {
                return;
            }

            const module = el.module;
            const id = module.id || module._id;

            if (!Object.hasOwnProperty(id)) {
                this.moduleRefs[id] = el;
            }
        },
        addModule(index) {

            let module = {
                _id: uniqueId('module'),
                title: '',
                position: index + 1,
            };

            this.moduleRefs = {};

            this.form.modules.splice(index, 0, module);

            this.updateModulePositions();

            this.$nextTick(() => {
                this.selectModule(module);
            })
        },
        removeModule(module) {

            this.moduleRefs = {};

            if (!module.id) {
                this.form.modules = this.form.modules.filter(item => item !== module);
                this.updateModulePositions();
            } else if (window.confirm(this.removeModuleConfirmMessage)) {
                this.form.modules = this.form.modules.map((item, i) => {
                    if (item.id === module.id) {
                        item.remove = true;
                        keys(this.form.errors.errors)
                            .filter(name => name.indexOf(`modules.${i}`) === 0)
                            .forEach(name => this.form.errors.clear(name));
                    }

                    return item;
                });
                this.updateModulePositions();
            }
        },
        selectModule(module) {
            this.moduleRefs[module.id || module._id].focus();
        },
        moduleUpdated(module) {
            this.lastEdited = module;
        },
        updateModulePositions() {
            let position = 1;
            for (const module of this.form.modules) {
                if (!module.remove) {
                    module.position = position;
                    position++;
                }
            }
        },
        updateMultipart(multipart) {
            if (multipart) {
                return this.form.multipart = true;
            }

            if (this.hasUpcomingSessions) {
                if (!window.confirm('Are you sure? This will remove all but the first session from all upcoming session groups.')) {
                    return this.$refs.multipart.mainElement().checked = true;
                }
            }

            this.form.multipart = false;
        }
    },

    computed: {
        modules() {
            return this.form.modules;
        },
        hasError() {
            return !!keys(this.form.errors.errors).filter(item => item.indexOf('modules') === 0).length;
        },
        hasUpcomingSessions() {
            return this.course.upcoming_session_groups_count > 0;
        },
        removeModuleConfirmMessage() {
            return this.hasUpcomingSessions
                ? 'This will remove all upcoming sessions related to this module. Are you sure you want to continue?'
                : 'Are you sure you want to delete this module?';
        }
    },

    watch: {
        'form.modules': {
            deep: true,
            handler() {
                this.form.errors.clear('modules')
            }
        },
        'form.multipart'() {
            keys(this.form.errors.errors)
                .filter(name => name.indexOf('modules') === 0)
                .forEach(name => this.form.errors.clear(name));
        }
    },
};


</script>
